const activeCommitmentsStyle = () => ({
	simpleTable: {
		paddingTop: 16,
		'& > div > div:last-of-type > div > div': {
			paddingLeft: 8,
		},
	},
	summary: {
		paddingTop: 20,
		paddingBottom: 20,
	},
});

export default activeCommitmentsStyle;
